"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteColumnHeader = exports.createHtmlFromQuoteColumnHeader = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var QuoteSectionBodyWidget_1 = require("../SharedWidgetComponents/QuoteSection/QuoteSectionBodyWidget");
var createHtmlFromQuoteColumnHeader = function (token) {
    return server_1.default.renderToString(react_1.default.createElement(QuoteSectionBodyWidget_1.ColumnHeader, {
        data: token["data"],
    }));
};
exports.createHtmlFromQuoteColumnHeader = createHtmlFromQuoteColumnHeader;
var QuoteColumnHeader = function (_a) {
    var token = _a.token;
    return react_1.default.createElement(QuoteSectionBodyWidget_1.ColumnHeader, { data: token["data"] });
};
exports.QuoteColumnHeader = QuoteColumnHeader;
